module.exports = __webpack_public_path__ + "static/printed-hard-cover-photo-book-487039efdecdcf14301f59db2549bf75.jpg";